import { observable } from 'mobx'
import {
	LicenseResponse,
	LicensingClient,
} from '../../api/clients/identity/LicensingClient'
import { registerNotificationCenterNotification } from '../../components/notificationCenter/NotificationCenterContext'
import { toastService } from '../notifications/ToastService'

type LicenseInfo =
	| {
			readonly status: 'loading'
			promise: Promise<LicenseResponse>
	  }
	| {
			readonly status: 'licensed'
			license: LicenseResponse
	  }
	| {
			readonly status: 'notLicensed'
	  }

const client = new LicensingClient()

const promise = client.GetLicense().then((v) => v.data)

const licenseInstance: { licenseInfo: LicenseInfo } = observable({
	licenseInfo: {
		status: 'loading',
		promise: promise,
	},
})

export function licensedFor(moduleName: string) {
	const licenseInfo = licenseInstance.licenseInfo
	if (licenseInfo.status !== 'licensed') return false

	const module = licenseInfo.license.modules[moduleName]
	if (module === undefined) return false

	const startDate = new Date(module.startDate)
	const endDate = new Date(module.expirationDate)
	const now = new Date()

	return startDate < now && endDate > now
}

export function licensedForAllFimFunctionality() {
	return (
		licensedFor('Forms inMotion Single Process') ||
		licensedFor('Forms inMotion Enterprise')
	)
}

let licenseCallback: (() => void) | null = null

export function onLicensedFor(
	moduleName: string,
	callback: (isLicensed: boolean) => void,
) {
	if (licenseInstance.licenseInfo.status !== 'loading')
		callback(licensedFor(moduleName))
	else licenseCallback = () => callback(licensedFor(moduleName))
}

export default licenseInstance

promise
	.then((v) => {
		licenseInstance.licenseInfo = {
			status: 'licensed',
			license: v,
		}
		if (licenseCallback !== null) licenseCallback()
	})
	.catch(() => {
		console.warn('not licensed')

		licenseInstance.licenseInfo = {
			status: 'notLicensed',
		}

		toastService.displayToast({
			area: 'global',
			message: 'Software not licensed',
			severity: 'error',
		})
		registerNotificationCenterNotification({
			title: 'Software Not Licensed',
			body: 'Forms inMotion is not licensed, some functionality will be disabled',
			status: 'error',
		})
	})
